import {BannerDef} from '../../components/banner/banner.component';

export const Banners: {
    energySaver: BannerDef,
    meterReading: BannerDef,
    meterConnecting: BannerDef,
    meterConnectingTutorial: BannerDef
} = {
    energySaver: {
        type: 'alert',
        prio: 1,
        main: 'Energiesparmodus:',
        sub: 'Datenübertragung nur nach größeren Veränderungen (>50W).',
        route: [
            'einstellungen',
            'energy-saver'
        ]
    },
    meterReading: {
        type: 'info',
        prio: 2,
        main: 'Bitte Zählerstand überprüfen',
        sub: 'Ihr Messstellenbetreiber benötigt von Ihnen einen aktuellen Zählerstand.',
        route: [
            '/'
        ],
        params: {
            detail: 'meter'
        }
    },
    meterConnecting: {
        type: 'info',
        prio: 3,
        main: 'Zähler wird verbunden...',
        sub: '',
        route: [
            '/registrieren'
        ],
        params: {
            jumpToMeterstate: true
        }
    },
    meterConnectingTutorial: {
        type: 'info',
        prio: 2,
        main: 'Zähler wird verbunden...',
        sub: '',
        route: [
            '/registrieren'
        ],
        params: {
            jumpToTutorial: true
        }
    }
};
